export default "__VITE_ASSET__DkEEttcu__"